var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "loading_show"
        },
        [_c("div", { staticClass: "spinner-border text-danger" })]
      ),
      _vm._v(" "),
      _vm.students.length > 0 && _vm.loading === false
        ? _c(
            "b-card-text",
            [
              _vm._l(_vm.students, function(student, index) {
                return _c("div", { staticClass: "tasklists-row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "row tasklist-item",
                      staticStyle: { margin: "0px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xl-5 col-5" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: { path: "/students-task/" + student.id }
                              }
                            },
                            [
                              _vm._v(
                                "\n       " +
                                  _vm._s(student.first_name) +
                                  " " +
                                  _vm._s(student.last_name) +
                                  "\n       "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xl-5  col-5 override-padding" },
                        [_vm._v(_vm._s(student.email))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xl-2 col-2 override-padding" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "dropdown",
                              attrs: { id: "dropdown-container" + index },
                              on: {
                                click: function($event) {
                                  return _vm.toggleDropdown(
                                    "actionDropdown" + index + ""
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "dropbtn icons btn-right showLeft",
                                  attrs: { id: "dotted-menu" + index }
                                },
                                [
                                  _c("li"),
                                  _vm._v(" "),
                                  _c("li"),
                                  _vm._v(" "),
                                  _c("li")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-content",
                                  attrs: { id: "actionDropdown" + index }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "action-dd-menu",
                                      on: {
                                        click: function($event) {
                                          return _vm.goToEdit(student.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "cursor-pointer fa fa-edit spacer-icon"
                                      }),
                                      _vm._v("Edit")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "action-dd-menu",
                                      on: {
                                        click: function($event) {
                                          return _vm.assignTasklist(student.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "cursor-pointer fa fa-upload spacer-icon"
                                      }),
                                      _vm._v("Assign Tasklist")
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [_c("hr")])
                ])
              }),
              _vm._v(" "),
              _vm.rows > _vm.perPage
                ? _c(
                    "div",
                    {
                      staticClass:
                        "overflow-auto float-right pagination-wrapper"
                    },
                    [
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.rows,
                          "per-page": _vm.perPage,
                          "first-text": "First",
                          "prev-text": "Prev",
                          "next-text": "Next",
                          "last-text": "Last",
                          "hide-goto-end-buttons": "0"
                        },
                        on: {
                          input: function($event) {
                            return _vm.goToPagination()
                          }
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.students.length == 0 && _vm.loading === false
        ? _c("div", { staticClass: "noitems-custom-msg" }, [
            _vm._v("No students assigned for this group")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-739cc09c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-739cc09c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primaryadmin/studentlists.vue
// module id = null
// module chunks = 